import { WizCommand, WizRoot } from '@wizeoo/akm-component-lib';
import { DataPack, DataPackSet } from '@wizeoo/akm-message-lib';
import { ExternalAPI } from '../../model/external-api';
import { Model } from '../../model/model';
import { DataLoadObj } from '@wizeoo/akm-compute-lib';
import { DataCommitCmd } from './datacommit.cmd';

/**
 * Appels du service de check
 * Author LMA
 */
export class DataCheckCmd extends WizCommand<DataPack> {
  
  protected model: Model = null;

  constructor(model: Model) {
    super();
    this.model = model;
  }


  public sourcePack: DataPack = null; // les packs transmis au service

  /** check */
  public check(callback: Function): DataCheckCmd {
    this.sourcePack = this.buildPack();
    this.sourcePack.originUuid = WizRoot.getInstance().uuid; // prise de l'origine unique
    this.configureRemote(ExternalAPI.DATA_CHECK_API, this.sourcePack, callback);

    return this;
  }

  /** Execution call
   * @override pour persistence locale des EMs (pour replay sur échec)
   */
  public async execute(): Promise<any> {
    super.execute();
  }

  /**
   * utilisation du lock, ou pas (pas de lock si silent = true)
   * Attention, écrasé par commit (qui fait un configure), donc l'appeler APRES
   */
  public silent(silent: boolean = true): DataCheckCmd {
    this.doLock = !silent;
    return this;
  }

  /** construction du pack remote */
  private buildPack(): DataPack {
 
    let result: DataPack = new DataPack();

    result.domain = this.model.domainCode;
    result.businessUnitCode = this.model.businessUnitCode;
    result.visionCode = this.model.visionCode;
    result.login = this.model.connectedUser.mail;
    result.originUuid = WizRoot.getInstance().uuid;
    result.datas = {};

    /* ################################################
        gestion des freedatas
      ################################################ */

    // numRev pour les FDs
    result.freedataRevisionNumber = this.model.freedataSyncService.freedataLoad.revisionNumber;

    /* ################################################
        gestion des baselines & values
      ################################################ */

    let dataset: DataPackSet; // le set pour ajout des baselines / values par level / scen
    let vmap:Map<number, Map<string, DataLoadObj>> = this.model.dataMap.get(this.model.visionCode);
    let dlo: DataLoadObj;
    [...vmap?.keys() || []].forEach(level => {
      result.datas[level] = {};
      [...vmap.get(level)?.keys()].forEach(scenario => {
        dlo  = vmap.get(level).get(scenario);
        dataset = new DataPackSet();
        dataset.level = level;
        dataset.scenario = scenario;
        dataset.revNumber = dlo?.revisionNumber || -1;
        result.datas[level][scenario] = dataset;
      });
    });

    return result;
  }


  /** sur retour, traitement selon la méthode */
  public wizResult() {
    this.sourcePack = this.result;
    super.wizResult();
  }
}
